export default ({
  label = "", labelSuffix = ' : ', value = false,
  className = "",
  cursor = "cursor-default",
  onClick = () => {}
}) => (
  <div className={className || "flex items-center mb-2"}>
    <label className={`block text-sm font-medium text-gray-600 mr-2 ${cursor}`}>
      {label}{labelSuffix}
      <div className={`inline ${label ? "m-1" : ""}`}>
        <input type="checkbox" 
          className={`toggle toggle-primary ${cursor}`} 
          checked={value || false}
          readOnly
          onClick={onClick}
        />
      </div>
    </label>
  </div>
)